import React from "react";
import label from "../../labels/postExaminationProcessObjective_en.json";

const ExamData = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.ExamData} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default ExamData;
